import { render, staticRenderFns } from "./SimpleSwiper.vue?vue&type=template&id=029719b0&scoped=true"
import script from "./SimpleSwiper.vue?vue&type=script&lang=js"
export * from "./SimpleSwiper.vue?vue&type=script&lang=js"
import style0 from "./SimpleSwiper.vue?vue&type=style&index=0&id=029719b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029719b0",
  null
  
)

export default component.exports